export default __webpack_public_path__ + "static/media/vongthan.5d1144fb.png";